import { render, staticRenderFns } from "./FileUploaderTransparentTableCustom.vue?vue&type=template&id=39274d0e&scoped=true"
import script from "./FileUploaderTransparentTableCustom.vue?vue&type=script&lang=js"
export * from "./FileUploaderTransparentTableCustom.vue?vue&type=script&lang=js"
import style0 from "./FileUploaderTransparentTableCustom.vue?vue&type=style&index=0&id=39274d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39274d0e",
  null
  
)

export default component.exports